import {
  getName,
  getProfilePictureUrl,
  TSalesManager,
} from '@internal/services/TSalesManager'
import { ImageTransformations } from '@internal/utils/media/Media'
import { FC } from 'react'

type Props =
  | {
      variant: 'avatar'
      salesManager: TSalesManager
      size: number
      className?: string
    }
  | {
      variant: 'indoors' | 'outdoors'
      salesManager: TSalesManager
      width: number
      height: number
      className?: string
    }

export const ProfilePicture: FC<Props> = (props) => {
  let transformations: ImageTransformations = {
    focus: 'face',
    zoom: 0.3,
  }

  if (props.variant === 'avatar') {
    transformations.width = props.size
    transformations.height = props.size
    transformations.radius = 'max'
  } else {
    transformations.width = props.width
    transformations.height = props.height
  }

  if (!props.salesManager.zohoUserId) {
    return null
  }

  return (
    <img
      className={props.className}
      loading='lazy'
      alt={getName(props.salesManager)}
      width={transformations.width}
      height={transformations.height}
      src={getProfilePictureUrl({
        id: props.salesManager.id,
        variant: props.variant,
        zohoUserId: props.salesManager.zohoUserId,
        transformations,
      })}
    />
  )
}
